// source: extensions.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.com.google.scout.chorus.proto.omitFromDb', null, global);
goog.exportSymbol('proto.com.google.scout.chorus.proto.overwriteWhenMerging', null, global);

/**
 * A tuple of {field number, class constructor} for the extension
 * field named `omitFromDb`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.com.google.scout.chorus.proto.omitFromDb = new jspb.ExtensionFieldInfo(
    50001,
    {omitFromDb: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[50001] = new jspb.ExtensionFieldBinaryInfo(
    proto.com.google.scout.chorus.proto.omitFromDb,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[50001] = proto.com.google.scout.chorus.proto.omitFromDb;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `overwriteWhenMerging`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */
proto.com.google.scout.chorus.proto.overwriteWhenMerging = new jspb.ExtensionFieldInfo(
    50002,
    {overwriteWhenMerging: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[50002] = new jspb.ExtensionFieldBinaryInfo(
    proto.com.google.scout.chorus.proto.overwriteWhenMerging,
    jspb.BinaryReader.prototype.readBool,
    jspb.BinaryWriter.prototype.writeBool,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[50002] = proto.com.google.scout.chorus.proto.overwriteWhenMerging;

goog.object.extend(exports, proto.com.google.scout.chorus.proto);
